<template>
    <div id="app">
        <RwvHeader
            v-if="
                ![
                    'OrderProofReview',
                    'OrderProofView',
                    'pendingPayment'
                ].includes($route.name)
            "
        />
        <OrderProofReviewHeader
            v-else-if="
                ['OrderProofReview', 'OrderProofView'].includes($route.name)
            "
        />
        <router-view :key="$route.path"></router-view>
        <RwvFooter
            v-if="
                ![
                    'DesignStudioNew',
                    'DesignStudio',
                    'DesignStudioV2',
                    'DesignStudioV3',
                    'DesignStudioBuildV3',
                    'pendingPayment',
                    'checkoutV3',
                    'reviewpay'
                ].includes($route.name)
            "
            class="no-print"
        />
    </div>
</template>
<script>
import { LOGOUT } from "@/store/actions.type.js";

export default {
    name: "App",
    components: {},
    created() {
        if (this.$route.query.preview === "true") {
            const hasReloaded = sessionStorage.getItem(
                "preview_reloaded_for_logout"
            );
            if (hasReloaded) {
                sessionStorage.removeItem("preview_reloaded_for_logout");
                this.$store.dispatch(LOGOUT);
                localStorage.removeItem("adminLoggedIn");
                const newQuery = { ...this.$route.query };
                delete newQuery.preview;
                this.$router.replace({ query: newQuery });
            }
        }
    },
    watch: {
        $route(to) {
            if (["OrderProofReview", "OrderProofView"].includes(to.name)) {
                document.body.classList.add("pt-0");
            } else {
                document.body.classList.remove("pt-0");
            }
            if (
                [
                    "DesignStudioNew",
                    "DesignStudio",
                    "DesignStudioV2",
                    "DesignStudioV3",
                    "DesignStudioBuildV3"
                ].includes(to.name)
            ) {
                document.body.classList.add("design-studio-view");
            } else {
                document.body.classList.remove("design-studio-view");
            }
            if (["business_credit_app"].includes(to.name)) {
                document.body.classList.add("credit-page");
            } else {
                document.body.classList.remove("credit-page");
            }
        }
    }
};

// $(document).ready(function(){
//   $("body").removeClass("bg_primary_light_white");
// });
</script>
<style>
.tooltip {
    display: block !important;
    z-index: 10000;
}
.tooltip .tooltip-inner {
    background: black;
    color: white;
    border-radius: 16px;
    padding: 5px 10px 4px;
}
.tooltip .tooltip-arrow {
    width: 0;
    height: 0;
    border-style: solid;
    position: absolute;
    margin: 5px;
    border-color: black;
    z-index: 1;
}
.tooltip[x-placement^="top"] {
    margin-bottom: 5px;
}
.tooltip[x-placement^="top"] .tooltip-arrow {
    border-width: 5px 5px 0 5px;
    border-left-color: transparent !important;
    border-right-color: transparent !important;
    border-bottom-color: transparent !important;
    bottom: -5px;
    left: calc(50% - 5px);
    margin-top: 0;
    margin-bottom: 0;
}
.tooltip[x-placement^="bottom"] {
    margin-top: 5px;
}
.tooltip[x-placement^="bottom"] .tooltip-arrow {
    border-width: 0 5px 5px 5px;
    border-left-color: transparent !important;
    border-right-color: transparent !important;
    border-top-color: transparent !important;
    top: -5px;
    left: calc(50% - 5px);
    margin-top: 0;
    margin-bottom: 0;
}
.tooltip[x-placement^="right"] {
    margin-left: 5px;
}
.tooltip[x-placement^="right"] .tooltip-arrow {
    border-width: 5px 5px 5px 0;
    border-left-color: transparent !important;
    border-top-color: transparent !important;
    border-bottom-color: transparent !important;
    left: -5px;
    top: calc(50% - 5px);
    margin-left: 0;
    margin-right: 0;
}
.tooltip[x-placement^="left"] {
    margin-right: 5px;
}
.tooltip[x-placement^="left"] .tooltip-arrow {
    border-width: 5px 0 5px 5px;
    border-top-color: transparent !important;
    border-right-color: transparent !important;
    border-bottom-color: transparent !important;
    right: -5px;
    top: calc(50% - 5px);
    margin-left: 0;
    margin-right: 0;
}
.tooltip.popover .popover-inner {
    background: #f9f9f9;
    color: black;
    padding: 24px;
    border-radius: 5px;
    box-shadow: 0 5px 30px rgba(black, 0.1);
}
.tooltip.popover .popover-arrow {
    border-color: #f9f9f9;
}
.tooltip[aria-hidden="true"] {
    visibility: hidden;
    opacity: 0;
    transition: opacity 0.15s, visibility 0.15s;
}
.tooltip[aria-hidden="false"] {
    visibility: visible;
    opacity: 1;
    transition: opacity 0.15s;
}
</style>
